import React, { Component, useEffect } from "react";
import PreviewHeader from "./component/PreviewHeader";
import PreviewSidebar from "./component/PreviewSidebar";
import Preview from "./component/Preview";
import Sidebardata from "../Publish/SidebarLeft";
import { displayUseCase, widgetEmbed } from "./useCases";
import { IFRAME_URL, WIDGET_URL } from "../../../../actions/api";
import DisplayPreview from '../Preview';

import './display-publish.css';
import { useNavigate } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { getInitialRoute } from "../../../../utils";
import { checkTheme, getWidgetWallData } from "../../../../actions/wallDataAction";
import { useDispatch } from "react-redux";
import { screenShot } from "../../../../actions/appsMoreAction";
import { DISPLAY_URL } from "../../../../actions/api";


const initialState = {
    product: null,
    step: 1,
    useCase: null,
    useCaseData: {},
    widgetOptions: widgetEmbed
}

const resetOptions = (options, index) => {
    return options.map(item => {
        if (item.id == index) {
            return { ...item, classActive: "active show" };
        }
        return { ...item, classActive: "" };
    })
}

const DisplayPublish = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { wallData } = useSelector(state => state.wallData, shallowEqual)
    const { userData } = useSelector(state => state.authenticated, shallowEqual);
    const wallKey = userData?.user?.user_key ?? '';
    const publicAccess = wallData?.wall?.Personalization?.publicAccess ?? 0;
    useEffect(() => {
        if (!wallData?.wall?.Personalization) dispatch(getWidgetWallData(localStorage.getItem('ownerId'), localStorage.getItem('wallId')))
    }, [])
    return <DP navigate={navigate} dispatch={dispatch} wallData={wallData} wallKey={wallKey} publicAccess={publicAccess} />
}

class DP extends Component {
    constructor(props) {
        super(props);
        this.state = initialState
    }

    componentDidMount() {
        if (window.location.href.includes('widget')) {
            this.selectProduct('widget')
            this.setState({ product: 'widget' })
            setTimeout(() => {
                this.selectUseCaseType({
                    "id": 1,
                    "title": "Embed Widget On HTML Website",
                    "name": "Html",
                    "videoURL": "531736063",
                    "popupID": "html",
                    "classActive": ""
                })
            }, 500);
        }
    }
    // take screenshot to share for sharing the interactive widget via facebook and twitter. It will run only if there is no such ss take before.
    getWidgetScreenShot = ({ wallId, ownerId }) => {

        const uploaderLink = `${IFRAME_URL}${wallId}`;
        const data = { wallId, domainName: uploaderLink, screenshotSize: ["1920x1080"], ownerId };
        screenShot(data).then(res => { }).catch(err => { console.error(err) });
    }

    selectProduct = (value) => {
        const { widgetOptions } = this.state;
        let useCase = null;
        let options = widgetOptions;
        if (value == 'display') {
            useCase = displayUseCase[0].value;
        } else if (value == 'widget') {
            useCase = 'widget';
        }
        else {
            useCase = null;
            options = resetOptions(options, 'no-match');
        }

        this.setState({ product: value, useCaseData: null, widgetOptions: options, useCase, step: 2 });
    }

    selectUseCase = (value, index) => {
        const { step } = this.state;

        let data = null;
        if (step > 2) {
            data = Sidebardata()[index][0];
        }
        this.setState({ useCaseData: data, useCase: value });
    }

    backAction = () => {
        const { step, widgetOptions } = this.state;
        let previousStep = (step - 1) > 0 ? step - 1 : 1;
        let previousState = this.state;
        if (previousStep == 1) {
            previousState = { ...initialState };
        } else {
            previousState['useCaseData'] = null;
            previousState['step'] = previousStep;
            previousState['widgetOptions'] = resetOptions(widgetOptions, 'no-match');
        }
        this.setState({ ...previousState });
        if (step == 1) this.props.navigate(`/wall/index/${localStorage.getItem('wallId')}`)
    }

    selectUseCaseType = (data) => {
        const { product, widgetOptions } = this.state;
        let options = widgetOptions;
        if (product == 'widget') {
            options = resetOptions(options, data.id);
        }
        this.setState({ useCaseData: data, step: 3, widgetOptions: options });
    }

    generateCode = () => {
        const { useCaseData, product, useCase, widgetOptions } = this.state;
        let data = useCaseData;
        const index = useCase == 'projector' ? 0 : useCase == 'signage' ? 1 : 2;
        let options = widgetOptions;
        if (useCaseData == null) {
            if (product == 'display') {
                data = Sidebardata()[index][0];
            } else {
                options = resetOptions(options, 1);
                data = options[0];
            }
        }
        this.setState({ useCaseData: data, widgetOptions: options, step: 3 });
    }

    componentDidUpdate() {
        const { wallData, dispatch } = this.props;
        const product = getInitialRoute();
        const themeId = wallData ? wallData.wall?.Personalization?.ThemeRule.themeId : null;
        if (wallData && (product == 'socialwalls' && themeId && themeId < 62)) {
            dispatch(checkTheme({ wallId: wallData.wallId, themeId, status: 1, ownerId: wallData.wallOwner }, wallData, 62));
        }
    }

    render() {
        const { step, product } = this.state;
        const { wallData, wallKey, publicAccess } = this.props;
        const wallId = localStorage.getItem('wallId');
        const themeId = wallData && Object.keys(wallData).length > 0 ? wallData.wall ? wallData.wall.Personalization?.ThemeRule?.themeId : null : null;

        return wallData ? (themeId && themeId > 61) ? <div>
            <PreviewHeader backAction={this.backAction} step={step} />

            {/* { Don't remove image tag it is used to take screenshot of the widget for interactive section when an pervious screenshot doesnot exist } */}
            {wallData?.wall?.Personalization?.interactive ? <img src={`https://cloud.tagbox.com/media/wall-branding/${wallId}/wallId_widget_${wallId}.jpg`} className="d-none screenshot-image-view" onError={(e) => this.getWidgetScreenShot({ wallId: wallId, ownerId: wallData.wallOwner })} /> : null}

            <div className="">
                <PreviewSidebar {...this.state} selectProduct={this.selectProduct} selectUseCase={this.selectUseCase} themeId={themeId} />
                <div className="">
                    <Preview {...this.state} url={`${product == 'widget' ? WIDGET_URL : DISPLAY_URL}/${wallId}?preview=1${publicAccess ? `&wallKey=${wallKey}` : ""}`} selectUseCaseType={this.selectUseCaseType} getCode={this.generateCode} selectProduct={this.selectProduct} wallData={wallData} />
                </div>
            </div>
        </div> : <DisplayPreview /> : null
    }
}

export default DisplayPublish;